export class Pessoa_Documentos
{
    id_psdc: number = 0;
    id_pessoa: number = 0;
    id_doc: number = 0;
    valor_psdc: string = '';
    id_uf: number = 0;
}